const brandHosts = {
  'smartparcel.gotoubi.com': 'UBI',
  'eparcel.gotoubi.com': 'UBI',
  'smartparcel.au.gotoubi.com': 'UBI',
  'stage-ubi.etowertech.com': 'UBI',
  'qa-ubi.etowertech.com': 'UBI',
  'pre-ubi.etowertech.com': 'UBI',
  'ubi.etowertech.com': 'UBI',
  'shipper.ubismartparcel.com': 'UBI',
  'ebay.walltechsystem.cn': 'ebay',
  'eparcel.dlqianrun.com': 'ebay',
  'qrl.etowertech.com': 'qrl',
  'parcels.wiseway.com.au': 'wiseway',
  'wiseway.etowertech.com': 'wiseway',
  'postnl.etowertech.com': 'Spring',
  'spring.etowertech.com': 'Spring',
  'spring.hk.etowertech.com': 'Spring',
  'yusen.sh.etowertech.com': 'Yusen',
  'directlink.etowertech.com': 'postnord',
  'directlinkamericas.etowertech.com': 'postnord',
  'apg.etowertech.com': 'APG',
  'crane.etowertech.com': 'Crane',
  'stage.etowertech.com': 'Crane',
  'qa-crane.etowertech.com': 'Crane',
  'charterlogistics.etowertech.com': 'charter',
  'qa-charterlogistics.etowertech.com': 'charter',
  'evcargo.etowertech.com': 'evCargo',
  'qa-evcargo.etowertech.com': 'evCargo',
  'postnord.etowertech.com': 'postnord',
  'qa-postnord.etowertech.com': 'postnord',
  'stage-postnord.etowertech.com': 'postnord',
  'seseecommerce.gotoubi.com': 'UBI_SPWW',
  'seseecommerce.ubismartparcel.com': 'UBI_SPWW',
  'tracking.etowertech.com': 'eTower',
  'tracking-qa.etowertech.com': 'eTower',
  'tracking-stage.etowertech.com': 'eTower',
  'tracking-pre.etowertech.com': 'eTower',
  'localhost:5000': 'eTower',
  'localhost:5001': 'eTower'
}

export default function getBrand(host) {
  localStorage.setItem('systemHost', host)
  host = host || window.location.host
  return brandHosts[host] ? brandHosts[host] : 'eTower'
}
